import { useEffect, useRef } from "react";

function ProductText({ text }) {
  const spanRef = useRef(null);

  useEffect(() => {
    const el = spanRef.current;
    if (!el) return;

    const lineHeight = parseFloat(getComputedStyle(el).lineHeight);
    const maxHeight = lineHeight * 3; // max 2 lines
    if (el.scrollHeight > maxHeight) {
      // reduce font-size slightly
      const currentSize = parseFloat(getComputedStyle(el).fontSize);
      el.style.fontSize = `${currentSize * 0.92}px`; // reduce by 10%
    }
  }, [text]);

  return (
    <span ref={spanRef} title={text}>
      {text}
    </span>
  );
}
export default ProductText;
